module.exports = __webpack_public_path__ + "img/tree-04-c-leaves.83c8b8ca.png";